"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const i18next_1 = __importDefault(require("i18next"));
const api_1 = require("@/api");
const chevron_down_svg_1 = __importDefault(require("@@/assets/svgs/chevron_down.svg"));
const detect_utils_1 = require("@/common/detect_utils");
const functions_1 = require("@/common/functions");
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const localeObjArr = [
    {
        countryCode: 'kr',
        lang: 'ko',
        langName: '한국어',
    },
    {
        countryCode: 'us',
        lang: 'en',
        langName: 'English',
    },
    {
        countryCode: 'jp',
        lang: 'ja',
        langName: '日本',
    },
    {
        countryCode: 'cn',
        lang: 'zh_hans',
        langName: '汉语',
    },
];
function default_1({ isMemberMenu }) {
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const open = Boolean(anchorEl);
    const openMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const currentLang = (0, detect_utils_1.currentLanguage)();
    const currentLocaleObj = localeObjArr.find(obj => obj.lang === currentLang) || localeObjArr[0];
    const onSelectLanguage = (lang) => {
        if (lang !== currentLang) {
            i18next_1.default.changeLanguage(lang);
            (0, api_1.getData)(`/room/language/?language=${lang === 'zh_hans' ? 'zh-hans' : lang}`)
                .then(() => {
                (0, api_1.postData)('/room/language/', null).catch(() => { });
            })
                .catch(() => { });
        }
    };
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const isMemberMenuOrPC = isMemberMenu || !maxWidth768;
    const flagImgDivCss = {
        position: 'relative',
        flexShrink: 0,
        display: 'flex',
        width: isMemberMenuOrPC ? '20px' : '22px',
        '&:after': (0, functions_1.afterImgWrapper)({ borderRadius: '2px' }),
        '> img': {
            width: '100%',
            borderRadius: '2px',
        },
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    display: 'flex',
                    alignItems: 'center',
                    columnGap: '5px',
                    height: isMemberMenuOrPC ? '32px' : '40px',
                    padding: isMemberMenuOrPC ? '0 7px 0 8px' : '0 10px',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    '#lang_name': {
                        display: isMemberMenu ? 'block' : 'none',
                        fontSize: '16px',
                    },
                }, "aria-controls": open ? 'language_menu' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: openMenu }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ css: flagImgDivCss }, { children: (0, jsx_runtime_1.jsx)("img", { alt: currentLocaleObj.lang, src: `https://flagcdn.com/w20/${currentLocaleObj.countryCode}.webp`, srcSet: `https://flagcdn.com/w40/${currentLocaleObj.countryCode}.webp 2x` }) })), (0, jsx_runtime_1.jsx)("span", Object.assign({ id: "lang_name" }, { children: currentLocaleObj.langName })), isMemberMenuOrPC && (0, jsx_runtime_1.jsx)(chevron_down_svg_1.default, { css: { width: '16px', height: '16px' } })] })), (0, jsx_runtime_1.jsx)(Menu_1.default, Object.assign({ id: "language_menu", anchorEl: anchorEl, autoFocus: false, disableScrollLock: true, open: open, onClose: handleClose, onClick: handleClose, slotProps: { paper: { sx: { borderRadius: '4px' } } }, MenuListProps: {
                    sx: {
                        '.MuiMenuItem-root': {
                            columnGap: '10px',
                            p: '8px 10px',
                            fontSize: '16px',
                            '> img': { width: '20px' },
                        },
                        '.Mui-selected': { bgcolor: '#f8f8f8 !important' },
                        '> li:first-of-type': {
                            borderRadius: '4px 4px 0 0',
                        },
                        '> li:last-of-type': {
                            borderRadius: '0 0 4px 4px',
                        },
                    },
                }, anchorOrigin: { vertical: isMemberMenu ? 'center' : 'bottom', horizontal: 'center' }, transformOrigin: { vertical: isMemberMenu ? 'center' : 'bottom', horizontal: 'center' } }, { children: localeObjArr.map(obj => ((0, jsx_runtime_1.jsxs)(MenuItem_1.default, Object.assign({ selected: currentLang === obj.lang, onClick: () => onSelectLanguage(obj.lang) }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ css: flagImgDivCss }, { children: (0, jsx_runtime_1.jsx)("img", { alt: obj.lang, src: `https://flagcdn.com/w20/${obj.countryCode}.webp`, srcSet: `https://flagcdn.com/w40/${obj.countryCode}.webp 2x` }) })), obj.langName] }), `language_menuitem_${obj.countryCode}`))) }))] }));
}
exports.default = default_1;
